import api from 'services/api';
import {
  PUSH_SUBSCRIPTIONS_PATH,
  PUSH_VAPID_PUBLIC_KEY_PATH,
} from './constants';
import {
  PushSubscriptionPayload,
  VapidPublicKeyResponse,
} from './types';

export async function fetchVapidPublicKey(): Promise<string> {
  const { data } = await api.get<VapidPublicKeyResponse>(
    PUSH_VAPID_PUBLIC_KEY_PATH,
  );

  if (!data?.publicKey) {
    throw new Error('Chave VAPID pública não retornada pela API');
  }

  return data.publicKey;
}

export async function registerPushSubscription(
  payload: PushSubscriptionPayload,
): Promise<void> {
  await api.post(PUSH_SUBSCRIPTIONS_PATH, payload);
}

export async function removePushSubscription(endpoint: string): Promise<void> {
  await api.delete(PUSH_SUBSCRIPTIONS_PATH, {
    data: { endpoint },
  });
}
